var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-n3 mb-n3"},[_c('detail-banner',{staticClass:"pl-2",attrs:{"title":_vm.$t('_common:pages.help.title'),"src":_vm.bannerImage}}),_c(_vm.component,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }